<template>
    <div class="emails">
      <NavBar :admin="true" :items="items" />
      <v-main>
        <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
        <v-container v-else>
          <p class="text-h5 mt-2">Planos SMS</p>
          <v-list flat>
            <v-list-item-group>
              <v-list-item
                v-for="plan in smsPlans"
                :key="plan.id"
                style="border: 1px solid #e0e0e0; border-radius: 5px"
                color="primary"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon color="primary">mdi-message-processing</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{plan.quantity}} SMS - {{plan.price / 100}}€</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="primary--text">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" @click="onEditSMSPlan(plan)">
                        <v-icon color="primary">edit</v-icon>
                      </v-btn>
                    </template>
                    <span v-translate>Edit</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <p class="text-h5 mt-2">Notificações</p>
          <v-dialog v-if="selectedPlan" v-model="showEditSMSPlan" max-width="70%" scrollable>
            <v-card>
              <v-card-title class="title primary--text mb-2 secondary">
                <translate>Edit plan</translate>
              </v-card-title>
              <v-card-text class="pt-2">
                <v-form ref="editPlanForm">
                  <v-row no-gutters>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="selectedPlan.quantity"
                        label="Quantidade"
                        outlined
                        :rules="[required]"
                        type="number"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="selectedPlan.price"
                        :label="$gettext('Price')"
                        outlined
                        :rules="[required]"
                        class="px-2"
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="primary darken-1" text @click="showEditSMSPlan = false">
                  <translate key="close">Close</translate>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="editSMSPlan" :loading="loadingEditPlan">
                  <translate key="save">Save</translate>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <template>
            <p v-if="emails.length == 0" class="font-weight-thin ml-2" v-translate key="no-payments">No emails.</p>
            <Email v-else v-for="email in emails" :key="email.id" @edit-email="editEmail" :email="email" :isSMS="true" />
          </template>
          <p class="text-h5 mt-10">Informação</p>
          <v-row no-gutters class="mt-4 mb-4">
            <v-col cols="12" sm="12">
              <v-form ref="infoForm">
                <v-col cols="12" sm="12">
                  <v-textarea outlined label="Email Info PT" v-model="info.email_info_pt" class="px-2" />
                  <v-textarea outlined label="Email Info EN" v-model="info.email_info_en" class="px-2" />
                  <v-textarea outlined label="Email Info ES" v-model="info.email_info_es" class="px-2" />
                </v-col>
                <v-col cols="12" sm="12">
                  <v-textarea outlined label="SMS Info PT" v-model="info.sms_info_pt" class="px-2" />
                  <v-textarea outlined label="SMS Info EN" v-model="info.sms_info_en" class="px-2" />
                  <v-textarea outlined label="SMS Info ES" v-model="info.sms_info_es" class="px-2" />
                </v-col>
                <v-col cols="12" sm="12">
                  <v-btn depressed color="secondary" class="ml-2 primary--text float-right" @click="editInfo" :loading="savingInfo">
                    <translate>Save</translate>
                  </v-btn>
                </v-col>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </div>
  </template>
  
  <script>
  import NavBar from "@/components/authentication/NavBar.vue";
  import Email from "@/components/admin/Email.vue";
  import axios from "axios";
  
  export default {
    name: "Emails",
    components: {
      NavBar,
      Email
    },
    data: () => ({
      loading: false,
      showEditSMSPlan: true,
      selectedPlan: null,
      emails: [],
      smsPlans: [],
      info: {},
      loadingEditPlan: false,
      savingInfo: false
    }),
    computed: {
      items() {
        return [
          {
            text: this.$gettext("Dashboard"),
            disabled: false,
            link: true,
            to: {name: 'dashboard'}
          },
          {
            text: this.$gettext("Email & SMS"),
            disabled: true,
            link: true
          }
        ];
      },
      required() {
        return value => !!value || this.$gettext("Required.");
      }
    },
    methods: {
      editEmail(email) {
        let m = this.emails.find(e => e.id === email.id);
        Object.assign(m, email);
      },
      editSMSPlan() {
        if(this.$refs.editPlanForm.validate()) {
          this.loadingEditPlan = true;

          axios
            .post("/admin/sms-plans/" + this.selectedPlan.id + "/edit", this.selectedPlan)
            .then(response => {
              let plan = this.smsPlans.find(p => p.id === this.selectedPlan.id);
              plan.quantity = response.data.sms_plan.quantity;
              plan.price = response.data.sms_plan.price;

              this.loadingEditPlan = false;
              this.showEditSMSPlan = false;
            })
            .catch(error => {
              console.log(error);
              this.loadingEditPlan = false;
              this.showEditSMSPlan = false;
            });
        }
      },
      onEditSMSPlan(plan) {
        this.selectedPlan = plan;
        this.showEditSMSPlan = true;
      },
      editInfo() {
        if(this.$refs.infoForm.validate()) {
          this.savingInfo = true;

          const form = new FormData();
          form.append("email_info_pt", this.info.email_info_pt);
          form.append("email_info_en", this.info.email_info_en);
          form.append("email_info_es", this.info.email_info_es);
          form.append("sms_info_pt", this.info.sms_info_pt);
          form.append("sms_info_en", this.info.sms_info_en);
          form.append("sms_info_es", this.info.sms_info_es);

          axios
            .post("/admin/email-sms/info/edit", form)
            .then(response => {
              console.log("DONE", response.data);

              this.info = response.data.info;
              this.savingInfo = false;
            })
            .catch(error => {
              console.log(error);
              this.savingInfo = false;
            });
        }
      }
    },
    created() {
      this.loading = true;

      axios
        .get("/admin/email-sms")
        .then(response => {
          console.log(response.data);
          this.emails = response.data.emails;
          this.smsPlans = response.data.sms_plans;
          this.info = response.data.info;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    }
  }
  </script>